import React from 'react';
import HrnbCard from '../controls/HrnbCard';
import HrnbProgressBar from '../controls/HrnbProgressBar';
import '../../css/components/DuelVotingResults.css';

const DuelVotingResults = ({ duelId, round, votesResults }) => {
    if (!votesResults || !votesResults.results) {
        return null;
    }

    const { results, totalVotes, winnerId } = votesResults;

    return (
        <HrnbCard title="Результаты голосования" className="duel-voting-results-card">
            <div className="duel-voting-results-summary">
                <div className="duel-voting-total">
                    <span className="duel-voting-total-value">{totalVotes || 0}</span>
                    <span className="duel-voting-total-label">всего голосов</span>
                </div>
                {winnerId && (
                    <div className="duel-voting-winner">
                        <span className="duel-voting-winner-icon">🏆</span>
                        <span>Победитель раунда</span>
                    </div>
                )}
            </div>

            <div className="duel-voting-results-list">
                {results.map((result, index) => {
                    const isWinner = result.participantId === winnerId;
                    const percentage = result.percentage || 0;

                    return (
                        <div
                            key={result.participantId}
                            className={`duel-voting-result-item ${isWinner ? 'winner' : ''}`}
                        >
                            <div className="duel-voting-result-header">
                                <div className="duel-voting-result-participant">
                                    <span className="duel-voting-result-rank">#{index + 1}</span>
                                    <div className="duel-voting-result-avatar">
                                        {result.avatar ? (
                                            <img src={result.avatar} alt={result.displayName} />
                                        ) : (
                                            <span>{result.displayName?.[0]?.toUpperCase() || '?'}</span>
                                        )}
                                    </div>
                                    <span className="duel-voting-result-name">
                                        {result.displayName}
                                        {isWinner && <span className="duel-voting-winner-badge">🏆 Победитель</span>}
                                    </span>
                                </div>
                                <div className="duel-voting-result-stats">
                                    <span className="duel-voting-result-votes">{result.votesCount} голосов</span>
                                    <span className="duel-voting-result-percentage">{percentage.toFixed(1)}%</span>
                                </div>
                            </div>

                            <div className="duel-voting-result-bar">
                                <HrnbProgressBar
                                    value={percentage}
                                    max={100}
                                    variant={isWinner ? 'success' : 'primary'}
                                    showLabel={false}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            {votesResults.votingClosed && (
                <div className="duel-voting-results-closed">
                    <span className="duel-voting-closed-icon">🔒</span>
                    <p>Голосование завершено</p>
                </div>
            )}
        </HrnbCard>
    );
};

export default DuelVotingResults;
